<script>
import { AlertComponent as Alert } from 'vue-elder-alert'
import { ButtonComponent } from 'vue-elder-button'
import Tabs from '@/components/Tabs'
import Providers from './Providers'
import Pointers from './Pointers'
import Card from '@/components/Card-v2'
import Bus from '@/bus'

export default {
  props: {
    domain: String,
  },
  watch: {
    '$route.hash': {
      handler(val) {
        if (val === '#chat') {
          Bus.$emit('chat')
        }
      },
      immediate: true,
    },
    domain: {
      handler: 'checkDns',
      immediate: true,
    },
    dnsIsValid(newValue, oldValue) {
      this.$emit('update:dnsValidation', newValue)
    },
  },
  data() {
    return {
      provider: 'Other',
      status: [],
      loading: false,
    }
  },
  computed: {
    isNo() {
      return this.$store.state.enums.Region.value === 'NO'
    },
    providers() {
      return [
        this.isNo ? { id: 'Domeneshop', label: 'Domeneshop' } : null,
        this.isNo ? { id: 'Webhuset', label: 'Webhuset' } : null,
        { id: 'Other', label: this.$t('other') },
      ].filter(Boolean)
    },
    dnsIsValid() {
      if (!this.status || !this.status.length) return false
      return this.status.every(i => i.valid)
    },
    dnsSteps() {
      if (!this.status || !this.status.length) return {}

      return Object.fromEntries(this.status.map(item => [item.type, item.valid]))
    },
    pointers() {
      if (!this.domain) return []
      const parts = this.domain.split('.')

      if (parts.length === 2)
        return [
          { type: 'CNAME', value: `www.${this.domain}`, target: window.location.hostname },
          { type: 'A', value: this.domain, target: '46.101.173.122' },
        ]

      if (parts.length === 3 && parts[0] === 'www')
        return [
          { type: 'CNAME', value: `${this.domain}`, target: window.location.hostname },
          { type: 'A', value: parts.slice(1).join('.'), target: '46.101.173.122' },
        ]

      return [{ type: 'CNAME', value: this.domain, target: window.location.hostname }]
    },
  },
  methods: {
    checkDns() {
      this.loading = true

      fetch(`/api/dns/verify?domain=${this.domain}`)
        .then(res => res.json())
        .then(res => {
          this.status = res
        })
        .finally(() => (this.loading = false))
    },
  },

  components: {
    Alert,
    Tabs,
    ButtonComponent,
    Pointers,
    Card,
    ...Providers,
  },
}
</script>

<template>
  <div class="dns-instructions">
    <ButtonComponent
      class="dns-instructions__retry"
      theme="primary"
      :label="$t('retry')"
      :icon="['fal', 'sync-alt']"
      :loading="loading"
      :disabled="dnsIsValid"
      @click="checkDns"
    />
    <div class="dns-instructions__below">
      <div v-if="!dnsIsValid" class="dns-instructions__status row g-2 mb-2">
        <Alert theme="warning" class="grow-1">
          {{ $t('validDnsSetupMessage') }}
        </Alert>
      </div>

      <Card variant="widget" :title="dnsIsValid ? '' : $t('dnsProviderPointerInstructionsTitle')">
        <template v-if="!dnsIsValid" #subtitle>
          <div class="col mt-2">
            <span>
              {{ $t('dnsProviderPointerInstructionsDescription') }}
            </span>
            <span v-if="isNo">
              Har du ikke kjøpt domene anbefaler vi <a href="domeneshop.no"> domeneshop.no</a> eller
              <a href="webhuset.no"> webhuset.no</a>
            </span>
          </div>
        </template>
        <div class="dns-instructions__content col g-2">
          <template v-if="!dnsIsValid">
            <strong> {{ $t('dnsProviderDomainStart') }}</strong>
            <Tabs theme="button" v-model="provider" :items="providers">
              <template v-slot:[provider]>
                <component
                  :is="provider"
                  :steps="dnsSteps"
                  :pointers="pointers"
                  class="dns-instructions__provider"
                ></component>
              </template>
            </Tabs>
          </template>

          <Pointers :steps="dnsSteps" :pointers="pointers" class="dns-instructions__provider"></Pointers>
          <Alert theme="primary" class="mt-2">
            <div
              v-html="
                $t('dnsProviderSelectionDescription', {
                  link: `<a href='${'#chat'}''> ${$t('here').toLowerCase()}</a>`,
                })
              "
            ></div>
          </Alert>
        </div>
      </Card>
    </div>
  </div>
</template>

<style lang="scss">
.dns-instructions {
  .alert {
    font-size: 1rem;
  }

  &__provider {
    li {
      padding-block: 0.1em;
    }
  }

  .tabs__tab {
    padding-top: 0;
  }

  .tabs__details a {
    text-decoration: underline;
  }
}
</style>
